module.exports = __webpack_public_path__ + "static/media/servicesBanner2.01cc577f.png";